import { HttpClient, HttpContext, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { HttpContextConfig } from '../models/http-context-config';
import { CONFIG } from '../interceptors/loader.interceptor';
import { environment } from 'src/environments/environment';

const notiAPI = `${environment.api}/notifications`;

@Injectable({
  providedIn: 'root'
})
export class NotificationService {
  // unread: BehaviorSubject<any> = new BehaviorSubject<any>(null);
  private notificationsSubject: BehaviorSubject<any> = new BehaviorSubject<any>(
    null
  );
  public notification = new BehaviorSubject<number[]>([0, 0]);
  isClosed = false;

  // unread:any;
  constructor(private http: HttpClient) {}

  closeDialog() {
    this.isClosed = true;

    setTimeout(() => {
      this.isClosed = false;
    }, 1000);
  }

  //Gestisce la lettura di una notifica
  getNotifications() {
    return this.notificationsSubject.asObservable();
  }
  //In conseguenza alla getNotifications setta una variabile true se una notifica viene letta
  setNotifications(notifications: any) {
    this.notificationsSubject.next(notifications);
  }

  getNotification(params?: any) {
    let config = new HttpContextConfig();
    config.noSpinner = true;
    return this.http.get<any>(notiAPI + '/index', {
      params,
      context: new HttpContext().set(CONFIG, config)
    });
  }

  unreadedNotifications(params?: any): Observable<any> {
    let config = new HttpContextConfig();
    config.noSpinner = true;

    return this.http.get<any>(notiAPI + '/unreadedNotifications', {
      params,
      context: new HttpContext().set(CONFIG, config),
      withCredentials: true
    });
  }

  set_Read(id_notifica: any, read: boolean, params?: any) {
    let config = new HttpContextConfig();
    config.noSpinner = true;
    return this.http.put<any>(
      notiAPI + `/${id_notifica}/switchRead`,
      { read },
      { params, context: new HttpContext().set(CONFIG, config) }
    );
  }

  getAllCategoryTypes() {
    return this.http.get<any>(notiAPI + '/getAllCategoryTypes');
  }

  markAsReadAllSelected(id: any) {
    return this.http.patch<any>(notiAPI + `/markAsReadAllSelected`, { id });
  }

  markAsUnreadAllSelected(id: any) {
    return this.http.patch<any>(notiAPI + `/markAsUnreadAllSelected`, { id });
  }

  destroyAllSelected(id: string[]) {
    //const params = new HttpParams().set('id', id)
    return this.http.delete<any>(notiAPI + `/destroyAllSelected`, { body: id });
  }
}
